import { action } from "typesafe-actions";

export enum actionTypes {
    GET_FILTERS = "GET_FILTERS",
    GET_FILTERS_SUCCESS = "GET_FILTERS_SUCCESS",
    GET_FILTERS_FAILURE = "GET_FILTERS_FAILURE",
    SET_PARSED_FILTERS = "SET_PARSED_FILTERS",
}

export interface IBranch {
    id?: number,
    name?: string,
    address?: string
}

export interface IDepot {
    id?: number,
    name?: string,
    Branch_id?: number
}

export interface IFilterRoute {
    id?: number,
    name?: string,
    shortName?: string
}

export interface IVehicle {
    id?: number,
    branch?: number,
    gosNomer?: string,
    Depot_id?: number,
    // brand?: string,
    model?: string,
    depotNumber?: number,
    routeType?: string,
    route_id?: number,
}

export interface IFilter {
    branches: Array<IBranch>;
    depots: Array<IDepot>;
    routes: Array<IFilterRoute>;
    vehicles: Array<IVehicle>;

    [column: string]: Array<IVehicle> | Array<IFilterRoute> | Array<IDepot> | Array<IBranch>;
}

export interface IFilterState {
    filters: IFilter,
    parsedFilters: IParsedFilters,
    isLoading: boolean,
    isLoaded: boolean,
    isError: boolean,
}

export interface IParsedVehicle {
    depotNumber: Array<{ depotNumber?: number, key?: number, primaryField?: number }>;
    gosNomer: Array<{ gosNomer?: string, key?: string, primaryField?: string }>;
    model: Array<{ model?: string, key?: string, primaryField?: string }>;
}

export interface IParsedFilters {
    branch: Array<{ id?: number, name?: string, key?: number, primaryField?: string, }>;
    depot: Array<{ id?: number, name?: string, key?: number, primaryField?: string }>;
    route: Array<{ id?: number, name?: string, key?: number, primaryField?: string }>;
    routeType: Array<{ name?: string, shortName?: string } & { key?: string, primaryField?: string }>;
    depotNumber: Array<{ depotNumber?: number, key?: number, primaryField?: number }>;
    gosNomer: Array<{ gosNomer?: string, key?: string, primaryField?: string }>;
    model: Array<{ model?: string, key?: string, primaryField?: string }>;

    [column: string]: Array<any>;
}

export const actions = {
    getFilters: () => action(actionTypes.GET_FILTERS),
    getFiltersSuccess: (filters: IFilter) => action(actionTypes.GET_FILTERS_SUCCESS, {filters}),
    getFiltersFailure: () => action(actionTypes.GET_FILTERS_FAILURE),
    setParsedFilters: (parsedFilters: IParsedFilters) => action(actionTypes.SET_PARSED_FILTERS, {parsedFilters})
};

const initialState: IFilterState = {
    filters: {
        vehicles: [],
        depots: [],
        branches: [],
        routes: [],
    },
    parsedFilters: {
        model: [],
        gosNomer: [],
        depotNumber: [],
        branch: [],
        depot: [],
        route: [],
        routeType: [],
    },
    isLoading: false,
    isLoaded: false,
    isError: false,
};

interface IAction {
    type: string,
    payload?: {
        filters: IFilter,
        parsedFilters: IParsedFilters,
    }
}

const reducer = (state: IFilterState = initialState, action: IAction): IFilterState => {
    switch (action.type) {
        case (actionTypes.GET_FILTERS_SUCCESS):
            return {
                ...state,
                filters: action.payload!.filters,
            };
        case (actionTypes.GET_FILTERS_FAILURE):
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case (actionTypes.SET_PARSED_FILTERS):
            return {
                ...state,
                parsedFilters: action.payload!.parsedFilters,
                isLoaded: true,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default reducer;
